// font awesome icons
import {
  faTwitter,
  faLinkedin,
  faMedium,
  faGoogle,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import {
  faUserCircle,
  faBars,
  faChevronDown,
  faSearch,
  faCircle,
  faChevronCircleRight,
  faChevronCircleLeft,
  faChevronLeft,
  faChevronRight,
  faLongArrowAltRight,
  faHeart,
  faThumbsUp,
  faTimes,
  faStar,
  faShareAlt,
  faBed,
  faBackspace,
  faHome,
  faUser,
  faEllipsisV,
  faEllipsisH,
  faPen,
  faCheck,
  faWallet,
  faCog,
  faSignOutAlt,
  faOutdent,
  faCaretDown,
  faMapMarker,
  faBuilding,
  faExclamationTriangle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faEye,
  faEyeSlash,
  faClone,
  faTrashAlt,
  faCalendar,
  faMoneyBillAlt,
  faQuestionCircle,
  faImages,
} from "@fortawesome/free-regular-svg-icons";

export default [
  faTwitter,
  faLinkedin,
  faMedium,
  faGoogle,
  faFacebook,
  // fas
  faUserCircle,
  faBars,
  faChevronDown,
  faSearch,
  faCircle,
  faChevronCircleRight,
  faChevronCircleLeft,
  faChevronLeft,
  faChevronRight,
  faLongArrowAltRight,
  faHeart,
  faThumbsUp,
  faTimes,
  faStar,
  faShareAlt,
  faBed,
  faBackspace,
  faHome,
  faUser,
  faEllipsisV,
  faEllipsisH,
  faPen,
  faCheck,
  faWallet,
  faCog,
  faSignOutAlt,
  faOutdent,
  faCaretDown,
  faMapMarker,
  faBuilding,
  faExclamationTriangle,
  faExclamationCircle,
  // far
  faEye,
  faEyeSlash,
  faClone,
  faTrashAlt,
  faCalendar,
  faMoneyBillAlt,
  faQuestionCircle,
  faImages,
];
